export const checkPubSubConfig = ({
  newGroup,
  newMainChannel,
  newPublishKey,
  newSubscribeKey,
  oldGroup,
  oldMainChannel,
  oldPublishKey,
  oldSubscribeKey,
}) => {
  if (!!newGroup && newGroup !== oldGroup) {
    return true;
  }

  if (!!newMainChannel && newMainChannel !== oldMainChannel) {
    return true;
  }

  if (!!newPublishKey && newPublishKey !== oldPublishKey) {
    return true;
  }

  return !!newSubscribeKey && newSubscribeKey !== oldSubscribeKey;
};
